import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["model"]
  static values = { makes: Object }

  updateModels(e) {
    const models = this.makesValue[e.target.value] || []
    const options = models.map(model => ({ value: model, text: model }))

    this.modelSelect.replaceOptions(options)
  }

  get modelSelect() {
    return this.modelTarget["select"]
  }
}
